<template>
    <ul class="hotspots-nav">
        <li
        role="button"
        v-bind:aria-label="hotspot.name"
        v-bind:tabindex="[ isNavMenuOpened || isHotspotPanelOpened ? '-1' : '0'  ]"
        v-bind:aria-hidden="[ isNavMenuOpened || isHotspotPanelOpened ? 'true' : 'false'  ]"
        v-for="hotspot in hotspotsContent"
        v-on:mouseenter="hotspotHover(hotspot.id)"
        v-on:focus="hotspotHover(hotspot.id)"
        v-on:mouseleave="this.$dispatch('unhover-hotspot')"
        v-on:blur="this.$dispatch('unhover-hotspot')"
        v-on:click="hotspotClick(hotspot.id, $index)"
        v-bind:class="{ 'visible' : isNavbarVisible, 'hover' : hotspotHovered === hotspot.id }"
        v-on:keyup.enter="hotspotClick(hotspot.id, $index)">

            <div class="hotspot-nav-item">
                <div>
                    <span class="number">{{ $index + 1 | addZero }}</span>
                    <span class="title">{{ hotspot.name }}</span>
                </div>
            </div>

        </li>
    </ul>
</template>

<script>
    import { openHotspotPanel } from '../vuex/actions'

    export default {
        props: ['hotspotsContent', 'hotspotHovered'],

        vuex: {
            getters: {
                isNavMenuOpened: state => state.isNavMenuOpened,
                isHotspotPanelOpened: state => state.isHotspotPanelOpened
            },
            actions: {
                openHotspotPanel
            }
        },

        data: function () {
            return {
                isNavbarVisible: false
            }
        },

        ready: function () {
            // Reveal animation
            this.$nextTick(function () {
                this.$set('isNavbarVisible', true)
            })
        },

        methods: {
            'hotspotClick': function (hotspotId, index) {
                this.openHotspotDetails(hotspotId, index)
                this.$dispatch('play-sound-once', 'hotspots-click')
            },

            'hotspotHover': function (hotspotId) {
                this.$dispatch('hover-hotspot', hotspotId)
                this.$dispatch('play-sound-once', 'hotspots-hover')
            },

            openHotspotDetails: function (hotspotId, hotspotNumber) {
                this.$router.go({
                    name: 'graham',
                    params: {
                        hotspot: hotspotId
                    }
                })
                let hotspotDetails = this.hotspotsContent.filter(hotspot => {
                    return hotspot.id === hotspotId
                })[0]
                this.openHotspotPanel(hotspotDetails, this.hotspotsContent)
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/sass/global';

    $hotspots-nav-dot-size: 7px;
    $hotspots-nav-dot-size-outter: 15px;
    $hotspots-nav-buttons-height: 8vh;

    $hotspots-nav-global-delay: 1.4s;

    .hotspots-nav {
        @include unstyleList();
        display: none;
        position: absolute;
        top: 50%;
        left: 6rem;
        transform: translateY(-50%);
        z-index: 2;

        @include gridle_state(large) {
            display: block;
        }

        li {
            position: relative;
            display: block;
            width: 100%;
            cursor: pointer;
            outline: 0;
            height: $hotspots-nav-buttons-height;

            &:not(:first-child) {
                .hotspot-nav-item {
                    border-right: 1px solid rgba($white, 0.6);
                }

                @for $i from 1 through 20 {
                    &:nth-child(#{$i}) {
                        .hotspot-nav-item {
                            transition-delay:  $hotspots-nav-global-delay + .2s * $i;
                        }
                    }
                }
            }

            @for $i from 1 through 20 {
                &:nth-child(#{$i}) {
                    .number {
                        transition-delay:  $hotspots-nav-global-delay + 0.4s + .2s * $i;
                    }
                }
            }

            &:nth-child(2) {
                .hotspot-nav-item {
                    transition: height .2s linear, border .2s linear;
                    border-color: rgba($white, 0);
                }
            }

            &.visible {
                .hotspot-nav-item {
                    height: $hotspots-nav-buttons-height;
                }

                .number {
                    opacity: 0.6;
                }

                &:nth-child(2) {
                    .hotspot-nav-item {
                        border-color: rgba($white, 0.6);
                    }
                }
            }

            .hotspot-nav-item {
                transition: height .2s linear;
                width: 100%;
                height: 0;
                overflow: hidden;

                &::after, &::before {
                    content: '';
                    display: block;
                    z-index: 2;
                    border-radius: 50%;
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    transform: translateX(50%) translateY(50%);
                    cursor: pointer;
                }

                &::after {
                    transition: width .3s ease-out, height .3s ease-out, opacity .1s ease-out;
                    background-color: $white;
                    width: 0;
                    height: 0;
                    opacity: 0;
                }

                &::before {
                    transition: width .3s ease-out .1s, height .3s ease-out .1s, opacity .1s ease-out;
                    border: 1px solid $white;
                    width: 0;
                    height: 0;
                    opacity: 0;
                    z-index: -1;
                }
            }

            &:hover, &:focus, &.hover {
                .title {
                    opacity: 1;
                }

                .number {
                    transition: opacity .3s ease-out;
                    opacity: 1;
                }

                .hotspot-nav-item {
                    &::after {
                        width: $hotspots-nav-dot-size;
                        height: $hotspots-nav-dot-size;
                        opacity: 1;
                    }

                    &::before {
                        width: $hotspots-nav-dot-size-outter;
                        height: $hotspots-nav-dot-size-outter;
                        opacity: 0.6;
                    }
                }
            }

            .number,
            .title {
                @include headingsStyle();
                color: $white;
                letter-spacing: 2px;
                font-size: 0.85rem;
                position: absolute;
                display: block;
                bottom: 0;
                padding: 2rem;
                white-space: nowrap;
            }

            .number {
                transition: opacity .3s ease-out 1.6s;
                right: 0;
                transform: translateY(50%);
                opacity: 0;
            }

            .title {
                transition: opacity .35s ease-out;
                left: 0;
                transform: translateY(50%);
                opacity: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// HotspotsNav.vue?0cef7fc2